import TermService from "../services/TermService.js";

const getTermByType = async (typeName, isCompose) => {
	if (typeName === "journalnote") typeName = "journal";
	const service = new TermService();
	const response = await service.get(typeName);
	const modules = response.module_term;

	const moduleTerms = {};

	for (const key in modules) {
		if (key.startsWith("namings_called_")) {
			const newKey = key.replace("namings_called_", "");
			if (typeof modules[key] === "string") {
				if (isCompose) {
					modules[key] = `${modules[key]}s`;
				}
				moduleTerms[`${newKey}_cap`] = modules[key];
				moduleTerms[`${newKey}`] = modules[key].toLowerCase();
			}
		}
	}
	return moduleTerms;
};

export const studentTerm = async () => getTermByType("student");
export const departmentTerm = async () => getTermByType("department");
export const journalTerm = async (isCompose = false) =>
	getTermByType("journal", isCompose);
export const dashboardTerm = async () => getTermByType("dashboard");
export const noteTerm = async () => {
	const response = await getTermByType("journalnote");
	let term = {};
	if (response.single === "dagbog") {
		term = {
			single_cap: "Dagbogsnotat",
			single_specific_cap: "Dagbogsnotatet",
			multi_cap: "Dagbogsnotater",
			multi_specific_cap: "Dagbogsnotaterne",

			single: "dagbogsnotat",
			single_specific: "dagbogsnotatet",
			multi: "dagbogsnotater",
			multi_specific: "dagbogsnotaterne",
		};
	}
	if (response.single === "journal") {
		term = {
			single_cap: "Journalnotat",
			single_specific_cap: "Journalnotatet",
			multi_cap: "Journalnotater",
			multi_specific_cap: "Journalnotaterne",

			single: "journalnotat",
			single_specific: "journalnotatet",
			multi: "journalnotater",
			multi_specific: "journalnotaterne",
		};
	}
	return term;
};

let fetchedModules = [];

const fetchTerms = async () => {
	const service = new TermService();
	fetchedModules = await service.getAll();
};

const termByModule = () => {
	const moduleTerms = {};
	for (const modules of fetchedModules) {
		moduleTerms[modules.module_name] = {};
		for (const key in modules) {
			if (key.startsWith("namings_called_")) {
				const newKey = key.replace("namings_called_", "");
				if (typeof modules[key] === "string") {
					moduleTerms[modules.module_name][`${newKey}_cap`] =
						modules[key];
					moduleTerms[modules.module_name][`${newKey}`] =
						modules[key].toLowerCase();
				}
			}
		}
	}
	getNoteTerm(moduleTerms);
	return moduleTerms;
};

const getNoteTerm = (terms) => {
	if (terms.journal.single === "dagbog")
		terms["note"] = {
			single_cap: "Dagbogsnotat",
			single_specific_cap: "Dagbogsnotatet",
			multi_cap: "Dagbogsnotater",
			multi_specific_cap: "Dagbogsnotaterne",

			single: "dagbogsnotat",
			single_specific: "dagbogsnotatet",
			multi: "dagbogsnotater",
			multi_specific: "dagbogsnotaterne",
		};
	else if (terms.journal.single === "journal")
		terms["note"] = {
			single_cap: "Journalnotat",
			single_specific_cap: "Journalnotatet",
			multi_cap: "Journalnotater",
			multi_specific_cap: "Journalnotaterne",

			single: "journalnotat",
			single_specific: "journalnotatet",
			multi: "journalnotater",
			multi_specific: "journalnotaterne",
		};
};

export const terms = async () => {
	await fetchTerms();
	const terms = termByModule();
	return terms;
};
